const ENV_CONFIGURATIONS = {
    API_BASE_URL: process.env.REACT_APP_API_BASE_URL,
    API_BASE_SOCKET_DOMAIN: process.env.REACT_APP_API_BASE_SOCKET_DOMAIN,
    FIREBASE_API_KEY: process.env.REACT_APP_FIREBASE_API_KEY,
    FIREBASE_AUTH_DOMAIN: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    FIREBASE_PROJECT_ID: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    FIREBASE_STORAGE_BUCKET: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    FIREBASE_MESSAGE_SENDER_ID: process.env.REACT_APP_FIREBASE_MESSAGE_SENDER_ID,
    FIREBASE_APP_ID: process.env.REACT_APP_FIREBASE_APP_ID,
    FIREBASE_MEASUREMENT_ID: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
    REACT_APP_STRIPE_API_KEY: process.env.REACT_APP_STRIPE_API_KEY,
    PAYHERE_CHECKOUT_URL: process.env.REACT_APP_PAYHERE_CHECKOUT_URL
}

export const CONFIGURATIONS = ENV_CONFIGURATIONS;
